<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Tiempo de respuesta de los servicios
                integrados. Indica si una integración
                está lenta o fallando. Úsalo para
                detectar problemas y avisar a soporte
                 antes de que impacte a los usuarios.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Latencia
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Visualiza la <b>latencia</b> de los servicios integrados en AVE.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Latencia</div> -->
          <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'latence'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <!-- Add button (only icon) -->
          <!--<button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>-->
          <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Glosario">
            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
          </button>
          <mat-menu #filterMenu="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #b19527;"></mat-icon>
              <span>En Progreso</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #15757d;"></mat-icon>
              <span>Éxito</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:minus-circle" style="color: #ffa800;"></mat-icon>
              <span>Terminado con Advertencias</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:x-circle" color="warn"></mat-icon>
              <span>Error</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource"
              (matSortChange)="changeSort($event)" matSort>
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Interfaz</th>
                <td mat-cell *matCellDef="let element" class="text-sm leading-tight">
                  <b class="f-10">{{ element.code }}</b><br><span class="uppercase">{{element.name}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
                <td mat-cell *matCellDef="let element" class="text-sm">{{ element?.type }}</td>
              </ng-container>
              <ng-container matColumnDef="dateStart">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Inicio Ejecución</th>
                <td mat-cell *matCellDef="let element" class="text-sm">{{ formatDate(element.dateStart, true)}}</td>
              </ng-container>
              <ng-container matColumnDef="dateEnd">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fin Ejecución</th>
                <td mat-cell *matCellDef="let element" class="text-sm">{{ formatDate(element.dateEnd, true) }}</td>
              </ng-container>
              <ng-container matColumnDef="result">
                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td mat-cell *matCellDef="let element" style="width: 5px;">
                  <button mat-button color="primary" [disabled]="!element.result"
                    (click)="element.result && openAnswerModal(element)">
                    <mat-icon *ngIf="element.result" svgIcon="heroicons_solid:chat-bubble-left-ellipsis"></mat-icon>
                    <mat-icon *ngIf="!element.result" svgIcon="heroicons_outline:chat-bubble-left-ellipsis"></mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left"></th>
                <td mat-cell *matCellDef="let element" class="px-6 text-left" style="width: 5px;">
                  <mat-icon svgIcon="heroicons_solid:check-circle" style="color: #15757d"
                    *ngIf="element.status == logStatusEnum.SUCCESS"></mat-icon>
                  <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #b19527;"
                    *ngIf="element.status == logStatusEnum.IN_PROGRESS"></mat-icon>
                  <mat-icon svgIcon="heroicons_solid:minus-circle" style="color: #ffa800"
                    *ngIf="element.status == logStatusEnum.WARNING"></mat-icon>
                  <mat-icon svgIcon="heroicons_solid:x-circle" style="color: red"
                    *ngIf="element.status == logStatusEnum.ERROR"></mat-icon>
                </td>
              </ng-container>
              <ng-container matColumnDef="duration">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Duración</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-left">{{ formatMiliSeconds(element.duration) }}
                </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Acción</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                  <button  *ngIf="element.status!= logStatusEnum.SUCCESS" mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones"
                    >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openLogModal(element)">
                      <mat-icon>visibility</mat-icon>
                      <span>Visualizar logs</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>
              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
            </table>
          </div>
        </div>
        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal para Pilas de Log -->
  <ng-template #logModal let-data>
    <div class="flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 bg-white h-full p-4">
      <div >
        <!-- Smart Grid with horizontal scroll -->
        <div class="overflow-x-auto bg-white">
          <app-smart-grid
            class="bg-white"
            [data]="dataSourceDetail.data"
            [columnDefs]="columnDefsDetail"
            [config]="gridConfigDetail"
            [loading]="false"
            [totalRecords]="totalDetailItems"
            (gridReady)="onGridReady($event)"
            (pageChanged)="onPageChanged($event)"
            (sortChanged)="onSortChanged($event)"
            (searchChanged)="onSearchChanged($event)">
          </app-smart-grid>
        </div>
      </div>
    <div class="flex items-center justify-end mt-auto">
        <button mat-stroked-button color="primary" (click)="onExport()">
        <mat-icon>download</mat-icon>
        Exportar
      </button>

      <button mat-button mat-dialog-close>Cerrar</button>
    </div>
    </div>
  </ng-template>

  <!-- Filtros -->
  <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()">
    <app-dates-filters [form]="form" [showDateCreationRange]="true" />

    <app-configuration-filters [form]="form" [company]="true"></app-configuration-filters>
  </app-filter>
</mat-sidenav-container>